import { MAX_VISIBLE_PURCHASE_MOTIONS_PA } from 'pricing-pages-ui/constants/MaxVisiblePurchaseMotions';
import { getMerchCardsToShow } from 'pricing-pages-ui/constants/merchCards/MerchCardsToShow';
import { suitePurchaseMotionsMapSelector } from 'pricing-pages-ui/selectors/PurchaseMotionSelectors';
import { useSelector } from 'react-redux';
export const useSuiteTileAuthedCTAsProps = ({
  productLevel
}) => {
  const suitePurchaseMotionsMap = useSelector(suitePurchaseMotionsMapSelector);
  const suitePurchaseMotions = (suitePurchaseMotionsMap === null || suitePurchaseMotionsMap === void 0 ? void 0 : suitePurchaseMotionsMap[productLevel]) || [];
  const numPurchaseMotions = Math.min(suitePurchaseMotions.length, MAX_VISIBLE_PURCHASE_MOTIONS_PA()) || 1;
  const crmSuiteCards = getMerchCardsToShow({});
  const maxPurchaseMotionsOnPage = crmSuiteCards.reduce((currentMax, tempProductLevel) => {
    const tempPurchaseMotions = (suitePurchaseMotionsMap === null || suitePurchaseMotionsMap === void 0 ? void 0 : suitePurchaseMotionsMap[tempProductLevel]) || [];
    const length = tempPurchaseMotions.length;
    return Math.max(currentMax, Math.min(length, MAX_VISIBLE_PURCHASE_MOTIONS_PA()));
  }, 0);
  const style = {
    minHeight: 'initial',
    paddingBottom: (maxPurchaseMotionsOnPage - numPurchaseMotions) * 55
  };
  return {
    style,
    numPurchaseMotions,
    maxPurchaseMotionsOnPage,
    purchaseMotions: suitePurchaseMotions
  };
};